import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../scripts/context";
import { SelectedNFTStyle } from "./style";

export default function SelectedNFT() {
  const {
    state: {
      contracts: {
        nft: {
          data: { seletedNFT, lockedNFT },
        },
      },
    },
  } = useContext(AppContext);
  const [image, setImage] = useState(seletedNFT.url);

  useEffect(() => {
    (
      async () => {
        const checkItem = seletedNFT.url.split(".")[seletedNFT.url.split(".").length - 1] === "json";
        if (checkItem) {
          const contractFile = await fetch(seletedNFT.url);
          const { image } = await contractFile.json();

          setImage(image);
        }
      }
    )();
  }, [seletedNFT]);

  return (
    <SelectedNFTStyle>
      <div className="image-container">
        {lockedNFT?.tokenID && (
          <div className="rocket-icon">
            <img src="/img/rocket.svg" alt="rocket icon" />
          </div>
        )}
        <img
          src={image}
          alt={seletedNFT.name || `NFT Card #${seletedNFT.tokenID.toString()}`}
          className="nft-image"
        />
      </div>
      <p className="selected-nft-info-text">
        Earning Potential of Staking Rewards
      </p>
    </SelectedNFTStyle>
  );
}
